import { Input, Typography } from 'antd';
import styled from 'styled-components';

import { QuestionCircleOutlined } from '@ant-design/icons';

export const GuideText = styled(Typography.Text)`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colorPrimary};
  cursor: pointer;
`;

export const GuideIcon = styled(QuestionCircleOutlined)`
  margin-left: 8px;
  color: ${({ theme }) => theme.colorPrimary};
`;

export const StylesheetTextArea = styled(Input.TextArea).attrs({
  style: {
    minHeight: 250,
  },
})``;
